import { 
    CREATE_DSR_TEMPLATE_REQUEST,
    CREATE_DSR_TEMPLATE_SUCCESS,
    CREATE_DSR_TEMPLATE_FAILURE,
    UPDATE_DSR_TEMPLATE_REQUEST, 
    UPDATE_DSR_TEMPLATE_SUCCESS, 
    UPDATE_DSR_TEMPLATE_FAILURE,
    UPDATE_DSR_TEMPLATE_RESET,
    CREATE_DSR_WITH_TEMPLATE_REQUEST,
    CREATE_DSR_WITH_TEMPLATE_SUCCESS,
    CREATE_DSR_WITH_TEMPLATE_FAILURE,
    CREATE_DSR_WITH_TEMPLATE_RESET
 } from '../../actions/dsr-template-actions-types'


const INITIAL_STATE_CREATE_DSR_TEMPLATE = { results: '' }

export function createDsrTemplateReducer(state = INITIAL_STATE_CREATE_DSR_TEMPLATE, action) {
    switch (action.type) {
        case CREATE_DSR_TEMPLATE_REQUEST:
			return { ...state, isLoading: true, results: "" };
		case CREATE_DSR_TEMPLATE_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case CREATE_DSR_TEMPLATE_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to create dsr template' }
        default:
            return state;
    }
}

const INITIAL_STATE_UPDATE_DSR_TEMPLATE = { results: '' }

export function updateDsrTemplateReducer(state = INITIAL_STATE_UPDATE_DSR_TEMPLATE, action) {
    switch (action.type) {
        case UPDATE_DSR_TEMPLATE_REQUEST:
			return { ...state, isLoading: true, results: {} };
		case UPDATE_DSR_TEMPLATE_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case UPDATE_DSR_TEMPLATE_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to update dsr template' };
        case UPDATE_DSR_TEMPLATE_RESET:
            return INITIAL_STATE_UPDATE_DSR_TEMPLATE
        default:
            return state;
    }
}

const INITIAL_STATE_CREATE_DSR_WITH_TEMPLATE = { results: '' }

export function createDsrWithTemplateReducer(state = INITIAL_STATE_CREATE_DSR_WITH_TEMPLATE, action) {
    switch (action.type) {
        case CREATE_DSR_WITH_TEMPLATE_REQUEST:
			return { ...state, isLoading: true, results: {} };
		case CREATE_DSR_WITH_TEMPLATE_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case CREATE_DSR_WITH_TEMPLATE_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to create dsr with template' };
        case CREATE_DSR_WITH_TEMPLATE_RESET:
            return INITIAL_STATE_CREATE_DSR_WITH_TEMPLATE
        default:
            return state;
    }
}